/**
 * TODO: The functionality in this file is *essentially* duplicated in
 * consumer-rx-form-summary.js. Any changes to this file should be duplicated
 * there until such a time when consumer-rx-form is updated to somehow reuse
 * the functionality in this module.
 */
(function (document) {
  const form = document.getElementById('product-option-form');
  // If no form is found, exit early.
  if (!form) return;
  const steps = form.querySelectorAll('[data-product-option-step]');
  const summary = form.querySelector('[data-product-option-price-summary]');
  const summaryContainer = form.querySelector('.product-option-form__summary');
  const currencySeparator = summary.dataset.productOptionCurrencySeparator;
  const currencySuffix = summary.dataset.productOptionCurrencySuffix === 'true';
  let currencySymbolPrefix, currencySymbolSuffix;
  if (currencySuffix) {
    currencySymbolPrefix = '';
    // Currencies that place the symbol _after_ the amount separate it with a
    // space, e.g. "199.95 $".
    currencySymbolSuffix = ` ${summary.dataset.productOptionCurrencySymbol}`;
  } else {
    currencySymbolPrefix = summary.dataset.productOptionCurrencySymbol;
    currencySymbolSuffix = '';
  }
  const currencyThousandIndicator = summary.dataset.productOptionCurrencyThousandIndicator || '';
  const summaryOptsList = createOptionsList();

  init();

  /**
   * Instantiate product-option summary section.
   */
  function init() {
    form.addEventListener('change', updateSummary);
    // Update summary on init.
    updateSummary();
    // Update active step padding on nav and modal open.
    if (window.componentEvents) {
      window.componentEvents.on('product-option-form-reset', updateSummary);
    }
  }

  /**
   * Create and insert empty list into which selected options are to be
   * injected on user selections.
   */
  function createOptionsList() {
    const list = document.createElement('UL');
    list.classList.add('price-list__options');
    summary.insertBefore(list, summary.lastElementChild);
    return list;
  }

  /**
   * Update the summary section on option selection.
   */
  function updateSummary() {
    updateSummaryItems();
    updateBasePrice();
    calculateSubtotal();
  }

  /**
   * Update summar items according to selected options.
   */
  function updateSummaryItems() {
    const selectedOptions = Array.from(form.querySelectorAll('[data-product-option-option-cost]:checked'));
    const items = selectedOptions.map(createNewOption);
    summaryOptsList.innerHTML = '';
    items.forEach((item) => summaryOptsList.appendChild(item));
  }

  /**
   * Create new list item from a selected option.
   */
  function createNewOption(option) {
    const item = document.createElement('LI');
    item.classList.add('price-item');
    const title = document.createElement('SPAN');
    title.classList.add('price-item__title');
    title.innerText = option.dataset.productOptionOptionLabel;
    const cost = document.createElement('SPAN');
    cost.classList.add('price-item__cost');
    const integer = option.dataset.productOptionOptionCost;
    const decimal = document.createElement('SPAN');
    decimal.classList.add('price-item__decimal');
    decimal.innerText = `${currencySeparator}00`;
    cost.innerText = `${currencySymbolPrefix}${formatLargeNumber(integer, currencyThousandIndicator)}`;
    cost.appendChild(decimal);
    if (currencySymbolSuffix) {
      cost.appendChild(document.createTextNode(currencySymbolSuffix));
    }
    item.appendChild(title);
    item.appendChild(cost);
    item.dataset.productOptionSummaryOptionCost = integer;
    return item;
  }

  /**
   * Change base price if an option is selected that updates it.
   */
  function updateBasePrice() {
    const base = summary.querySelector('[data-product-option-summary-base-price]');
    // Note: this selector matches the first element that matches this
    // selector. If there are more than one option selected that updates the
    // base price, this will only match the first one. However, that should
    // never be the case, as it makes no sense for two not mutually exclusive
    // options to change the base price.
    const item = form.querySelector('[data-product-option-option-base-price]:checked');
    if (item) {
      useUpdatedBasePrice(base, item);
    } else {
      restoreOriginalBasePrice(base);
    }
  }

  /**
   * Update the base price to use a special price as indicated in a form item’s
   * data-product-option-option-base-price attribute.
   */
  function useUpdatedBasePrice(base, item) {
    const updatedPrice = item.dataset.productOptionOptionBasePrice;
    base.dataset.productOptionSummaryBasePriceOriginal = base.dataset.productOptionSummaryBasePrice;
    base.dataset.productOptionSummaryBasePrice = updatedPrice;
    updateBaseDisplay(base);
  }

  /**
   * Restore the base price to its original.
   */
  function restoreOriginalBasePrice(base) {
    // If no original price is stored, do nothing.
    if (!base.dataset.productOptionSummaryBasePriceOriginal) return;

    base.dataset.productOptionSummaryBasePrice = base.dataset.productOptionSummaryBasePriceOriginal;
    delete base.dataset.productOptionSummaryBasePriceOriginal;
    updateBaseDisplay(base);
  }

  /**
   * Update the base price display according to its
   * data-product-option-summary-base-price attribute.
   */
  function updateBaseDisplay(base) {
    const parts = base.dataset.productOptionSummaryBasePrice.split(currencySeparator);
    const integer = base.querySelector('.price-item__integer');
    const decimal = base.querySelector('.price-item__decimal');
    integer.innerText = `${currencySymbolPrefix}${formatLargeNumber(parts[0], currencyThousandIndicator)}`;
    // If there is a decimal part, use it. Otherwise, use “00”.
    decimal.innerText = `${currencySeparator}${parts[1] || '00'}`;
  }

  /**
   * Calculate subtotal with the base price and the cost of each option.
   */
  function calculateSubtotal() {
    const base = summary.querySelector('[data-product-option-summary-base-price]');
    const options = summaryOptsList.childNodes;
    const subtotal = summary.querySelector('[data-product-option-summary-subtotal-price]');
    const decimalWrapper = document.createElement('SPAN');
    decimalWrapper.classList.add('price-item__decimal');
    // Prices may be expressed with a period or a comma as a separator.
    let cost = parseFloat(base.dataset.productOptionSummaryBasePrice.replace(',', '.'));
    options.forEach((option) => {
      // Prices may be expressed with a period or a comma as a separator.
      cost = cost + parseFloat(option.dataset.productOptionSummaryOptionCost.replace(',', '.'));
    });
    cost = cost.toFixed(2);
    const [ integer, decimal ] = cost.split('.');
    subtotal.innerText = `${currencySymbolPrefix}${formatLargeNumber(integer, currencyThousandIndicator)}`;
    decimalWrapper.innerText = `${currencySeparator}${decimal}`;
    subtotal.appendChild(decimalWrapper);
    if (currencySymbolSuffix) {
      subtotal.appendChild(document.createTextNode(currencySymbolSuffix));
    }
  }
})(document);
